<template>
  <div class="mainContainer" :style="loginImage">
    <TopHeader :pageTitle="pageHead" />
    <!----------------Main Page------------------------------------------>
    <div class="pageContainer shadow-lg rounded" fluid="sm">
      <div class="page-content">
        <SecondaryHeader @openSidepane="onClickChild" />
        <!------------Content Area-------------->
        <div :class="bodyPanel" class="hemant">
          <!-----------Registration Form---------------->
          <div class="form-container-wrapper">
            <h2 class="text-center mt-3">Change Password</h2>
            <b-form
              novalidate
              v-if="show"
              class="m-3"
              @submit.prevent="onChangePassword"
            >
              <!-- Password fields -->
              <b-form-group id="input-group-password">
                <label label-for="email" class="col-md-12 p-0">Email:</label>
                <b-form-input
                  id="email"
                  v-model="form.email"
                  type="email"
                  class="mb-3 input col-md-12"
                  autocomplete="off"
                  :disabled="true"
                ></b-form-input>
                <small class="field-text is-danger errorText">{{
                  errors.email
                }}</small>
              </b-form-group>
              <b-button
                type="submit"
                variant="primary"
                class="text-right"
                align="center"
                >Send Link</b-button
              >
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TopHeader from "@/components/BaseFiles/TopHeader.vue";
import SecondaryHeader from "@/components/BaseFiles/SecondHeader.vue";
// Import Images
import bgImage from "@/assets/img/dbTiles/BG.png";

export default {
  name: "ChangePassword",
  components: {
    TopHeader,
    SecondaryHeader,
  },
  data() {
    return {
      form: {
        email: "",
      },
      show: true,
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
      pageHead: "Change Password",
      errors: {},
      valid: true,
      bodyPanel: "contentWrapper shadow-lg mb-3 rounded bodyPanelOpen",
    };
  },
  methods: {
    ...mapActions(["changepassword"]),
    onClickChild(value) {
      if (value) {
        this.bodyPanel = "contentWrapper shadow-lg mb-3 rounded bodyPanel";
      } else {
        this.bodyPanel = "contentWrapper shadow-lg mb-3 rounded bodyPanelOpen";
      }
    },
    onChangePassword() {
      if (this.form.email == "") {
        this.error.push("Enter email");
      } else {
        this.changepassword(this.form);
      }
    },
  },
  mounted() {
    let getUserData = sessionStorage.getItem("getUserData");
    getUserData = JSON.parse(getUserData);
    // console.log("getUserData", getUserData);
    this.form.email = getUserData.email;
  },
};
</script>

<style lang="scss">
label,
input {
  position: relative;
  display: inline-block;
  margin-right: 2%;
  font-weight: 600;
  font-size: 13px;
}

.form-control {
  display: inline-block !important;
  font-size: 13px;
  font-weight: normal;
}

.contentWrapper {
  background: $color-white;
  position: relative;
  margin: 1rem 5rem;
  height: 84%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
<style lang="scss" scoped>
.bodyPanelOpen {
  margin-left: 18.5% !important;
}
.form-container-wrapper {
  border: 1px solid #ccc;
  max-width: 500px;
  margin: 10% auto;
  border-radius: 5px;
}
.form-control:disabled,
.form-control[readonly] {
  cursor: not-allowed;
}
</style>
